import {
  PortalArtigoModel,
  PortalCoursesConfig,
  PortalFaqConfig,
  PortalRelatedArticlesConfig,
  PortalStickyCta,
} from '../../../models/PortalArtigoModel'

export const createDefaultFaq = (): PortalFaqConfig => ({
  anchorId: 'faq',
  sectionId: 'faq-portal-artigo',
  items: [{ id: 'faq-1', question: '', answerText: '', answer: [] }],
  whatsapp: { href: '', description: [] },
})

export const createDefaultCta = (): PortalStickyCta => ({
  title: '',
  paragraphs: [],
  href: '',
  label: '',
})

export const createDefaultCourses = (): PortalCoursesConfig => ({
  anchorId: 'cursos',
  title: '',
  courseIds: [],
})

export const createDefaultRelatedArticles = (): PortalRelatedArticlesConfig => ({
  anchorId: 'artigos-relacionados',
  title: 'Artigos relacionados',
  articleSlugs: [],
})

export const createInitialArtigo = (): PortalArtigoModel => ({
  tipo: null,
  titulo: '',
  slug: '',
  resumo: '',
  status: 'RASCUNHO',
  imagemThumbUrl: '',
  imagemThumbAlt: '',
  tituloOg: '',
  descricaoOg: '',
  imagemOgUrl: '',
  imagemOgAlt: '',
  conteudo: [],
  tags: [],
  faq: null,
  cta: null,
  cursosRelacionados: null,
  artigosRelacionados: null,
})
